// Pop-up newsletter : déclenchement discret, une seule fois, inscription sans recharger la page.
if (!customElements.get('hf-popup')) {
  customElements.define(
    'hf-popup',
    class HfPopup extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        this.key = 'hf_popup';
        this.teaser = this.querySelector('[data-teaser]');
        // Pastille désactivée dans l'éditeur : elle reste toujours cachée.
        if (this.dataset.teaserOn === 'false') {
          this.teaser.remove();
          this.teaser = document.createElement('div');
        }
        if (window.Shopify?.designMode) return;

        // Un code est déjà actif (QR code d'un partenaire, lien promo…) : on ne propose rien de plus.
        if (/(^|;\s*)discount_code=/.test(document.cookie)) return;
        fetch('/cart.js', { credentials: 'same-origin' })
          .then((response) => response.json())
          .then((cart) => {
            if ((cart.discount_codes || []).some((code) => code.applicable)) this.cancel();
          })
          .catch(() => {});

        this.querySelector('[data-reopen]')?.addEventListener('click', () => this.open(true));
        this.querySelector('[data-teaser-close]')?.addEventListener('click', () => {
          this.remember('teaser_off');
          this.teaser.hidden = true;
        });

        const saved = this.read();
        if (saved?.state === 'subscribed' || saved?.state === 'teaser_off') {
          if (this.seenRecently()) return;
        }
        // Pop-up déjà fermé récemment : seule la pastille reste visible.
        if (this.seenRecently()) {
          if (saved?.state === 'closed') this.teaser.hidden = false;
          this.bindDialog();
          return;
        }
        this.bindDialog();
        // Sur le panier : pas d'ouverture surprise, mais la pastille propose l'offre.
        if (this.dataset.auto === 'false') {
          this.teaser.hidden = false;
          return;
        }

        this.armTriggers();
      }

      cancel() {
        this.cancelled = true;
        clearTimeout(this.timer);
        this.teaser.hidden = true;
      }

      bindDialog() {
        if (this.bound) return;
        this.bound = true;
        this.querySelectorAll('[data-close]').forEach((button) => button.addEventListener('click', () => this.close()));
        this.dialog.addEventListener('cancel', (event) => {
          event.preventDefault();
          this.close();
        });
        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.close();
        });
        this.querySelector('form').addEventListener('submit', (event) => this.submit(event));
        this.querySelector('[data-copy]').addEventListener('click', (event) => {
          navigator.clipboard?.writeText(this.dataset.code);
          event.currentTarget.textContent = 'Copié !';
        });
      }

      armTriggers() {
        // Trois déclencheurs : délai, défilement à mi-page, intention de sortie (ordinateur).
        this.trigger = this.trigger.bind(this);
        this.timer = setTimeout(this.trigger, (Number(this.dataset.delay) || 15) * 1000);
        this.onScroll = () => {
          const ratio = (window.scrollY + window.innerHeight) / document.documentElement.scrollHeight;
          if (ratio > 0.5 && window.scrollY > 600) this.trigger();
        };
        window.addEventListener('scroll', this.onScroll, { passive: true });
        this.onLeave = (event) => {
          if (event.clientY <= 0 && !event.relatedTarget) this.trigger();
        };
        if (window.matchMedia('(hover: hover)').matches) document.addEventListener('mouseout', this.onLeave);
      }

      disconnectedCallback() {
        clearTimeout(this.timer);
        window.removeEventListener('scroll', this.onScroll);
        document.removeEventListener('mouseout', this.onLeave);
      }

      read() {
        try {
          return JSON.parse(localStorage.getItem(this.key) || 'null');
        } catch (error) {
          return null;
        }
      }

      remember(state) {
        try {
          localStorage.setItem(this.key, JSON.stringify({ state, at: Date.now() }));
        } catch (error) {
          /* navigation privée : tant pis, on ne mémorise pas */
        }
      }

      seenRecently() {
        const saved = this.read();
        if (!saved) return false;
        if (saved.state === 'subscribed') return true;
        return Date.now() - saved.at < (Number(this.dataset.days) || 15) * 86400000;
      }

      // On évite d'interrompre : bannière cookies ouverte, tiroir du panier ouvert, section newsletter visible, autre fenêtre ouverte.
      busy() {
        const banner = document.querySelector('#shopify-pc__banner');
        if (banner && banner.offsetParent !== null) return true;
        if (document.querySelector('cart-drawer.active, dialog[open]:not(.hf-pop__dialog), .menu-drawer-container[open]')) return true;
        const club = document.querySelector('#newsletter');
        if (club) {
          const box = club.getBoundingClientRect();
          if (box.top < window.innerHeight && box.bottom > 0) return true;
        }
        return false;
      }

      trigger() {
        if (this.shown || this.cancelled || this.seenRecently()) return;
        if (this.busy()) {
          clearTimeout(this.timer);
          this.timer = setTimeout(this.trigger, 4000);
          return;
        }
        this.open();
      }

      open(fromTeaser = false) {
        if (this.cancelled && !fromTeaser) return;
        this.shown = true;
        this.teaser.hidden = true;
        clearTimeout(this.timer);
        window.removeEventListener('scroll', this.onScroll);
        document.removeEventListener('mouseout', this.onLeave);
        this.mobile = window.matchMedia('(max-width: 749px)').matches;
        // Sur mobile : panneau en bas d'écran, sans voile ; sur ordinateur : fenêtre centrée.
        if (this.mobile) this.dialog.show();
        else this.dialog.showModal();
        this.classList.add('is-open');
      }

      close() {
        const subscribed = !this.querySelector('[data-step-done]').hidden;
        this.remember(subscribed ? 'subscribed' : 'closed');
        this.classList.remove('is-open');
        this.dialog.close();
        // Fermé sans s'inscrire : la pastille reste pour y revenir plus tard.
        if (!subscribed) this.teaser.hidden = false;
      }

      submit(event) {
        event.preventDefault();
        const form = event.target;
        const input = form.querySelector('input[type="email"]');
        const error = this.querySelector('[data-error]');
        if (!input.value || !input.checkValidity()) {
          error.textContent = "Merci d'indiquer une adresse email valide.";
          error.hidden = false;
          input.focus();
          return;
        }
        error.hidden = true;
        const button = form.querySelector('[data-submit]');
        button.disabled = true;
        fetch(form.action || this.dataset.contactUrl, { method: 'POST', body: new FormData(form), credentials: 'same-origin' })
          .then((response) => {
            // Protection anti-robots de Shopify : on bascule sur l'envoi classique.
            if (/challenge/.test(response.url)) {
              form.submit();
              return;
            }
            if (!response.ok) throw new Error();
            this.success();
          })
          .catch(() => {
            error.textContent = 'Oups, réessayez dans un instant.';
            error.hidden = false;
          })
          .finally(() => (button.disabled = false));
      }

      success() {
        this.remember('subscribed');
        this.querySelector('[data-step-form]').hidden = true;
        this.querySelector('[data-step-done]').hidden = false;
        const box = this.querySelector('[data-code-box]');
        box.classList.remove('hf-ticket__code--locked');
        box.textContent = this.dataset.code;
        this.querySelector('[data-stub-label]').textContent = 'Votre code';
        // Le code est mémorisé par Shopify et appliqué automatiquement au panier.
        if (this.dataset.code) fetch(`/discount/${encodeURIComponent(this.dataset.code)}`, { credentials: 'same-origin' }).catch(() => {});
      }
    }
  );
}
